<template>
  <div class="v-create-update-sim-card-form">
    <div class="modal-backdrop">
      <div class="modal">

        <header class="modal-header">
          <slot name="header">
            <h5 v-if="this.simCardId">Редактировать информацию о SIM карте</h5>
            <h5 v-else>Добавить новую SIM карту</h5>
            <button type="button" class="btn-close" @click="close">x</button>
          </slot>
        </header>

        <section class="modal-body">
          <slot name="body">
            <div v-if="this.loading">
              <div class="d-flex justify-content-center">
                <div class="spinner-grow m-5" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
            <div v-else class="pt-3">
              <form class="form" @submit.prevent="createUpdateSIMCard" autocomplete="nope">

                <div class="row mx-3">
                  <div class="col-4">
                    <div v-bind:class="[ this.simCardId  ? 'filled' : '' ]"
                         class="form-group">
                      <input v-mask="['+7 (###) ###-##-##', '+7 (###) ###-##-##']"
                             class="form-control"
                             required id="phone" v-model="inputs.phone_number"
                             @focusin="InputFocusIn('phone')"
                             @focusout="InputFocusOut('phone')"/>
                      <label for="phone">Номер телефона</label>
                    </div>
                  </div>
                  <div class="col-4">
                    <div v-bind:class="[ this.simCardId  ? 'filled' : '' ]"
                         class="form-group">
                      <input class="form-control" type="text" autocomplete="none"
                             required id="new_serial_number" v-model="inputs.new_serial_number"
                             @focusin="InputFocusIn('new_serial_number')"
                             @focusout="InputFocusOut('new_serial_number')"/>
                      <label for="new_serial_number">Серийный номер</label>
                    </div>
                  </div>
                  <div class="col-4">
                    <div v-bind:class="[ this.simCardId  ? 'filled' : '' ]"
                         class="form-group">
                      <input class="form-control" type="text" autocomplete="none"
                             required id="provider_account" v-model="inputs.provider_account"
                             @focusin="InputFocusIn('provider_account')"
                             @focusout="InputFocusOut('provider_account')"/>
                      <label for="provider_account">ЛК оператора</label>
                    </div>
                  </div>
                  <div class="col-4">
                    <datepicker v-model="inputs.activation_date" placeholder="Дата активации"
                          :language="ru" @input="inputs.activation_date = fixDateToFilter($event)"
                          input-class="form-control" wrapper-class="form-group"
                          id="activation_date" />
                  </div>
                  <div class="col-4">
                    <div v-bind:class="[ this.simCardId  ? 'filled' : '' ]"
                         class="form-group">
                      <input v-mask="['########', '########']"
                             class="form-control" type="text" autocomplete="none"
                             id="puk_code" v-model="inputs.puk_code"
                             @focusin="InputFocusIn('puk_code')"
                             @focusout="InputFocusOut('puk_code')"/>
                      <label for="puk_code">PUK</label>
                    </div>
                  </div>
                  <div class="col-4">
                    <div v-bind:class="[ this.simCardId  ? 'filled' : '' ]"
                         class="form-group">
                      <input class="form-control" type="text" autocomplete="none"
                             id="lk_psw" v-model="inputs.lk_psw"
                             @focusin="InputFocusIn('lk_psw')"
                             @focusout="InputFocusOut('lk_psw')"/>
                      <label for="lk_psw">Пароль</label>
                    </div>
                  </div>
                </div>

                <div class="row m-3">
                  <div class="col-6">
                    <div>
                      <textarea name="comment" rows="5" class="p-3" v-model="inputs.comment"
                        placeholder='Комментарий к карте, данные для входа в ЛК оператора и тп.'>
                      </textarea>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="row">
                      <div class="col-lg-6 pb-3">
                        <multiselect
                          v-model="inputs.tariff_group"
                          :options="tariffGroupList"
                          track-by="id"
                          label="name"
                          selectLabel=""
                          deselectLabel=""
                          placeholder="Группа тарифов">
                          <template slot="singleLabel" slot-scope="{ option }">
                            {{ option.name }}
                          </template>
                        </multiselect>
                      </div>
                      <div class="col-lg-6 pt-2 text-center">
                        <input
                          type="checkbox" class="form-check-input"
                          id="checkbox" v-model="inputs.is_alerted">
                        <label class="pl-3 form-check-label" for="checkbox">ALERT</label>
                      </div>
                      <div class="col-6 pb-3">
                        <multiselect
                          v-model="inputs.provider"
                          :options="providerList"
                          track-by="id"
                          label="name"
                          placeholder="Выберите оператора"
                          :allow-empty="false">
                          <template slot="singleLabel" slot-scope="{ option }">
                            {{ option.name }}
                          </template>
                        </multiselect>
                      </div>
                      <div class="col-6">
                        <multiselect
                          v-model="inputs.provider_agent"
                          :options="providerAgentList"
                          track-by="id"
                          label="name"
                          placeholder="Выберите поставщика"
                          :allow-empty="false">
                          <template slot="singleLabel" slot-scope="{ option }">
                            {{ option.name }}
                          </template>
                        </multiselect>
                      </div>

                      <div class="col-6">
                        <multiselect
                          v-model="inputs.dealer"
                          :options="dealerList"
                          track-by="id"
                          label="last_name"
                          placeholder="Выберите дилера"
                          :allow-empty="true">
                          <template slot="singleLabel" slot-scope="{ option }">
                            {{ option.last_name }}
                          </template>
                        </multiselect>
                      </div>
                      <div class="col-6">
                        <multiselect
                          v-model="inputs.employee"
                          :options="userList"
                          track-by="id"
                          label="last_name"
                          placeholder="Выберите сотрудника"
                          :allow-empty="true">
                          <template slot="singleLabel" slot-scope="{ option }">
                            {{ option.last_name }}
                          </template>
                        </multiselect>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mx-3 pt-4">
                  <div class="col">
                     <button v-if="this.simCardId" type="submit" class="btn btn-primary">
                       Обновить информацию
                     </button>
                     <button v-else type="submit" class="btn btn-primary">
                       Добавить SIM карту
                     </button>
                  </div>
                </div>
              </form>
            </div>
          </slot>
        </section>

      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { ru } from 'vuejs-datepicker/dist/locale';
import Multiselect from 'vue-multiselect';
import cardAPI from '../../api/simCard';

export default {
  name: 'v-create-update-sim-card-form',
  components: { Multiselect },
  props: ['simCardId'],
  data() {
    return {
      ru,
      loading: true,
      employeeList: [],
      inputs: {
        tariff_group: '',
        provider_account: '',
        phone_number: '',
        activation_date: null,
        serial_number: '',
        new_serial_number: '',
        lk_psw: '',
        puk_code: '',
        comment: '',
        provider: '',
        provider_agent: '',
        dealer: '',
        employee: '',
        is_alerted: false,
      },
    };
  },
  computed: {
    ...mapState('tariff', ['tariffGroupList', 'error']),
    ...mapState('user', ['dealerList', 'userList']),
    ...mapState('simCard', ['simCard', 'error']),
    ...mapState('provider', ['providerList']),
    ...mapState('providerAgent', ['providerAgentList']),
  },
  methods: {
    ...mapActions('simCard', ['getSIMCard']),
    ...mapActions('providerAgent', ['getProviderAgentList']),
    close() {
      this.$emit('close');
    },
    createUpdateSIMCard() {
      if (this.inputs.provider) {
        this.inputs.provider = this.inputs.provider.id;
      } else {
        this.inputs.provider = null;
      }
      if (this.inputs.provider_agent) {
        this.inputs.provider_agent = this.inputs.provider_agent.id;
      } else {
        this.inputs.provider_agent = null;
      }
      if (this.inputs.dealer) {
        this.inputs.dealer = this.inputs.dealer.id;
      } else {
        this.inputs.dealer = null;
      }
      if (this.inputs.employee) {
        this.inputs.employee = this.inputs.employee.id;
      } else {
        this.inputs.employee = null;
      }
      if (this.inputs.tariff_group) {
        this.inputs.tariff_group = this.inputs.tariff_group.id;
      }
      if (this.simCardId) {
        cardAPI.updateSIMCard(this.simCardId, this.inputs)
          .then(() => { this.close(); });
      } else {
        this.inputs.serial_number = this.inputs.new_serial_number;
        cardAPI.createSIMCard(this.inputs)
          .then(() => { this.close(); });
      }
    },
  },
  mounted() {
    this.getProviderAgentList('?get_all=true');
    if (this.simCardId) {
      cardAPI.getSIMCard(this.simCardId)
        .then((response) => {
          this.inputs = response.data;
          this.loading = false;
          if (this.inputs.provider) {
            this.inputs.provider = response.data.provider;
          }
          if (this.inputs.is_alerted) {
            this.inputs.is_alerted = true;
          }
          if (this.inputs.provider_agent) {
            this.inputs.provider_agent = response.data.provider_agent;
          }
          if (this.inputs.dealer) {
            this.inputs.dealer = response.data.dealer;
          } else {
            this.inputs.dealer = '';
          }
          if (this.inputs.employee) {
            this.inputs.employee = response.data.employee;
          } else {
            this.inputs.employee = '';
          }
        });
    } else {
      this.loading = false;
    }
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
